import { formatHex, modeOklch, modeRgb, useMode } from "culori/fn";
const rgb = useMode(modeRgb);
// do not remove; this modifies global state of culori
useMode(modeOklch);

export const cssOklchToCssHex = (oklchValue: string) => {
	// convert oklch or hex to hex
	const result = rgb(`${oklchValue}`) || rgb(`oklch(${oklchValue})`);
	if (!result) {
		return "";
	}
	return formatHex(result);
};
